const VectorSearchBelowRating = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="341"
    height="26"
    viewBox="0 0 341 26"
    fill="none"
    preserveAspectRatio="none"
  >
    <path
      d="M18.0139 15.6092L0 16.6792V26H341V16.6792H160C155.646 16.6792 151.479 14.9042 148.462 11.7639L145.173 8.33962L140.702 3.68654C138.44 1.33125 135.315 0 132.049 0H44.4566C41.3166 0 38.3018 1.23073 36.0588 3.42813L32.5 6.91468L28.2622 11.0665C25.5056 13.767 21.866 15.3803 18.0139 15.6092Z"
      fill="white"
    />
  </svg>
);

export default VectorSearchBelowRating;
